import React, { useEffect } from 'react';

const IframeSSO = () => {
  const tokenJWTAssinado =
    'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcGYiOiIxMDQ1MDA2NzY5NiIsIm5vbWUiOiJPcGEgZGV1IEJvbSBOb3ZvIiwiZW1haWwiOiJtYXJjaW9AbWFyY2lvLmNvbSIsImVtcHJlc2EiOiJNZXRhRG9jdG9yIiwiZXhwIjoxNzU2MzM0NDM1LCJpc3MiOiJNZXRhRG9jdG9yIiwiaWF0IjoxNzU2MzIwMDM1fQ.RZbozjyCNEKDIZgy12udHmuuDKZIs-UmQ834tgeOwWRLA-iS3dYsqSv_2rtmlQZpN9qBISOuenHmZsPgrAa6G1n6T2PMQPR7vUR1AzJJP0aFhijUplN2lglq6T3PryN79DSYScygDVia0VjeeAML3t5h_FZnkNRrMXsPWd0g5OdMzM3BlSg3EO5ct9CH8rRBs-tKlgDSpj-IBj6TQHOa4wM-eMXp-U17lJFfPxOB0yCLOkRUtqCKn9bLRPmelwFdSua7VOHE9NyI1sKvxWzmwr1qFWN2lJcXrzbsfcv7IU2YfKJOtPJZj8tLdW9lOgt0YWt4cW6iZHnYw1bTFiPgmg';

  useEffect(() => {
    const iframe = document.getElementById('iframeCM');
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.postMessage(
          {
            tokenEmpresa: 'empresa_abc123',
            tokenUsuario: tokenJWTAssinado,
          },
          'http://localhost:3001'
        );
      }, 100);
    };
  }, []);

  return (
    <iframe
      id="iframeCM"
      src="http://localhost:3001"
      style={{ width: '100%', height: '100vh', border: 'none' }}
      title="SSO CM"
    />
  );
};

export default IframeSSO;
